import { SliderImages } from '../../../components/swipper/SliderImages';
import CSS from 'csstype';
import CounterComponent from '../../../components/counter/CounterComponent';
import GeneralButtonComponent from '../../../components/button/GeneralButtonComponent';
import PropTypes from 'prop-types';

export const RestaurantCardElement = ({ title, type, images, reservable, isbar, userdata = null }) => {
    return (<>
        <div className='card-restaurant mt-8 relative'>
            <div className='flex flex-start'>
                <img src="/assets/img/icons/rest-icon.svg" alt="Mini icono" width="32px" height="32px" />
                <span className='title ml-2'>{title}</span>
            </div>

            {
                !isbar && (
                    <div className='mt-4 ml-10 type'><strong>Tipo de Comida:</strong> <span>{type}</span></div>
                )
            }

            <div className='flex justify-between items-center mt-4 mr-4'>
                <div className='flex items-center'>
                    <img src="/assets/img/icons/clock-icon.svg" alt="Clock icon" width={'25.35px'} height={'25.35px'} />
                    <span className='ml-1 type' style={timeTextStyles}>
                        <strong>Abre:</strong> 7:00 a.m.
                    </span>
                </div>
                <span className='type'>
                    <strong>Cierra:</strong> 7:00 p.m.
                </span>
            </div>

            <div className='mt-4'>
                <SliderImages items={images} />
            </div>

            <div>
                <p style={{ fontSize: '14px' }}>
                    Disfrute de la cocina tradicional japonesa y mejore su experiencia con un increíble espectáculo llameante en las mesas de Teppanyaki. Es la elección perfecta si desea una experiencia gastronómica única. Disfrute de la mejor experiencia gastronómica en Mikado.
                </p>
            </div>

            {
                reservable && (
                    <>
                        {
                            !userdata && (<div className='blocking'></div>)
                        }
                        <div className='flex justify-between items-center mt-4'>
                            <span style={{ fontSize: '14px' }}>Fecha de reservación:</span>
                            <div className="inline-block relative" style={{ width: '166px' }}>
                                <select className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-lg shadow leading-tight focus:outline-none focus:shadow-outline"
                                    style={{ height: '50px' }}>
                                    <option>1 - Dic - 2021</option>
                                    <option>2 - Dic - 2021</option>
                                    <option>3 - Dic - 2021</option>
                                </select>
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                                </div>
                            </div>
                        </div>

                        <div className='mt-4'>
                            <span style={{ fontSize: '14px' }}>
                                Número de Personas:
                            </span>
                            <div className='flex justify-between items-center mt-2'>
                                <CounterComponent />
                                <GeneralButtonComponent classes='primary_btn hover:primary_btn text-white py-3 px-6' bgcolor='#67BAAF' >Reservar</GeneralButtonComponent>
                            </div>
                        </div>
                    </>
                )
            }
        </div>
    </>);
};

const timeTextStyles: CSS.Properties = {
    color: '#4B5563'
}

RestaurantCardElement.propTypes = {
    title: PropTypes.string,
    type: PropTypes.string,
    images: PropTypes.array,
    isbar: PropTypes.bool,
    reservable: PropTypes.bool
}